<div class="w-full">
  @if (label) {
    <div class="flex items-center gap-1 mb-1">
      <label [for]="id || inputId" class="text-white font-medium text-[14px]">
        {{ label }}
      </label>

      @if (help) {
        <span class="relative inline-flex items-center cursor-pointer group">
          <mat-icon class="text-blue-500 text-[15px] group-hover:scale-110 transition-transform">
            help_outline
          </mat-icon>

          <span
            class="absolute left-0 top-[120%] z-10 w-[230px] bg-gray-800 text-white text-left rounded-md px-3 py-2 text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-300">
            {{ help }}
            <span
              class="absolute -top-2 left-2 w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-b-8 border-b-gray-800"></span>
          </span>
        </span>
      }
    </div>
  }

  <div
    [id]="id || inputId"
    tabindex="0"
    role="button"
    (click)="openPicker()"
    (keydown.enter)="openPicker()"
    (keydown.space)="openPicker()"
    (focusin)="onFocus()"
    (focusout)="onBlur()"
    class="relative w-full h-[30px] sm:h-[38px] px-3 bg-[#232326] border border-[#bebebe] rounded-[16px] text-white text-[15px] flex items-center gap-2 cursor-pointer transition-all duration-200"
  >
    <input
      matInput
      class="absolute inset-0 opacity-0 pointer-events-none"
      [formControl]="dateControl"
      [matDatepicker]="picker"
    />

    @if (startIcon) {
      <mat-icon class="text-[18px] text-gray-300">
        {{ startIcon }}
      </mat-icon>
    }

    <div class="flex-1 truncate text-gray-300">
      {{ displayValue || placeholder }}
    </div>

    @if (displayValue && !disabled) {
      <mat-icon
        class="text-[18px] cursor-pointer hover:text-white"
        (click)="clearValue($event)"
      >
        close
      </mat-icon>
    }

    @if (endIcon) {
      <mat-icon
        class="text-[18px]"
        [class.cursor-pointer]="!disabled"
        (click)="openPicker()"
      >
        {{ endIcon }}
      </mat-icon>
    }
  </div>

  @if (hasError && errorMessages) {
    <div class="text-xs text-gray-500 mt-1">
      {{ errorMessages }}
    </div>
  }

  @if (!hasError && !errorMessages && helperText) {
    <div class="text-xs text-gray-400 mt-1">
      {{ helperText }}
    </div>
  }

  <mat-datepicker #picker (closed)="onBlur()"></mat-datepicker>
</div>
